import HSGFooter from './Component/HSGFooter';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
    isAuthenticated: sessionStorage.getItem('isAuthenticated')
})

export default connect(mapStateToProps, null)(HSGFooter)




// WEBPACK FOOTER //
// ./src/Containers/HSGFooterContainer/index.js